import { AccessRegistryCardView } from "../../../AccessRegistryCardView";
import { ContentTableView } from "./ContentTableView";

export const AccessGroupCardControlView = () => (
  <AccessRegistryCardView badge highlights={["1", "2", "3"]}>
    <ContentTableView />
  </AccessRegistryCardView>
);
